import React from 'react';
import classNames from 'classnames';
import Icon, { COLORS, ICONS } from '../general-components/icon';

export interface RecordingStatusBannerProps {
	// 'row' lays the title and subtext side by side (Showbuilder canvas overlay);
	// 'stacked' puts the subtext under the title (go-live modal, Live Stream popover).
	layout?: 'row' | 'stacked';
	onClose?: () => void;
	className?: string;
}

export default function RecordingStatusBanner(props: RecordingStatusBannerProps) {
	const { layout = 'stacked', onClose, className } = props;

	return (
		<div
			className={classNames('recording-status-banner', `recording-status-banner--${layout}`, className)}
			data-testid="recording-status-banner"
		>
			<div className="recording-status-banner__badge">
				!
			</div>
			<div className="recording-status-banner__content">
				<span className="recording-status-banner__title">Stream recording is off</span>
				<span className="recording-status-banner__subtext">
					No recording will be generated. Turn on recording on the project details page.
				</span>
			</div>
			{onClose && (
				<button
					type="button"
					className="recording-status-banner__close transparent"
					onClick={onClose}
					aria-label="Dismiss recording status banner"
				>
					<Icon name={ICONS.CLOSE} color={COLORS.TEXT_GRAY_500} size={16} />
				</button>
			)}
		</div>
	);
}
